import React from 'react'
import styled from 'styled-components'
import get from 'lodash/get'
import VerticalTable from '../../metrolendar/vertical-table'
import KawariHelper from '../helper'

export default class TeamLeaveCalendar extends React.Component {
  // state = { moment: moment(), range: 'month' }
  // onMomentChange(moment) {
  //   this.setState({ moment })
  // }
  // onRangeChange(range) {
  //   this.setState({ range })
  // }
  render() {
    const events = KawariHelper.createTableMetrolendarEvents(
      get(this.props, 'data'), get(this.props, 'teamCalendar'), get(this.props, 'findLOBName'))
    const compensate = KawariHelper.createCompensateTableMetrolendarEvents(
      get(this.props, 'myCompensate'), get(this.props, 'teamCalendar'), get(this.props, 'findLOBName'), get(this.props, 'findFullNameByID'))
    const summary = KawariHelper.createTableMetrolendarSummary(
      get(this.props, 'data'), get(this.props, 'teamCalendar'))
    const publicHolidays = KawariHelper.createListMetrolendarPublicHoliday(get(this.props, 'publicHoliday'))
    const sumevents = [...events, ...compensate]

    return (
      <TeamLeave>
        {/* <TeamLeaveTop>
          <Top
            data={ this.props.data }
            onMomentChange={ this.onMomentChange.bind(this) }
            onRangeChange={ this.onRangeChange.bind(this) }
          />
        </TeamLeaveTop> */}
        <TeamLeaveContent>
          {/* <Side data={this.props.data}/> */}
          {this.props && get(this.props, 'moment') && get(this.props, 'range') && get(this.props, 'data') &&
            <VerticalTable
              events={ get(this.props, 'teamCalendar') ? get(this.props, 'searchLeaveRequest')(sumevents) : sumevents }
              summary={ summary }
              moment={ get(this.props, 'moment') }
              search={ get(this.props, 'search') }
              publicHolidays={ publicHolidays }
              range={ get(this.props, 'range') }
              myUser={ get(this.props, 'myUser') }
              teamCalendar={ get(this.props, 'teamCalendar') }
              handleClickCell={ get(this.props, 'handleClickCell') }
            />
          }
        </TeamLeaveContent>
      </TeamLeave>
    )
  }
}

const TeamLeave = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  > * {
    display: flex;
  }
`
const TeamLeaveContent = styled.div`
  height: 100%;
  width: 100%;
`



// WEBPACK FOOTER //
// ./src/components/kawari-calendar/team-leave/index.js